<div class="contenedorValidarDatosPersonales">
  <div class="subContenedorValidarDatosPersonales">
    <div class="seccionTitulo">
      <ion-text class="titulo">Confirma tus datos personales</ion-text>
      <ion-text class="subtitulo">Revisa que tus datos sean correctos, ya que te contactaremos en caso que sea necesario</ion-text>
    </div>
    <div class="seccionDatosPersonales">
      <div class="seccionDato">
        <ion-text class="descripcion">Correo:</ion-text>
        <ion-text class="valor" [class.sinRegistro]="!email">{{ email || 'Aún no registras tu correo' }}</ion-text>
      </div>
      <div class="seccionDato">
        <ion-text class="descripcion">Teléfono móvil:</ion-text>
        <ion-text class="valor" [class.sinRegistro]="!celular">{{ celular || 'Aún no registras tu teléfono' }}</ion-text>
      </div>
    </div>
    <h4 class="tusDatos">Si necesitas actualizar tu información puedes hacerlo en <a class="link" (click)="irDatosPersonales()" (keydown.enter)="irDatosPersonales()">Tus datos</a></h4>
  </div>
  <div class="action-container">
    <button class="b-btn s-button" (click)="exit()">Salir</button>
    <button class="b-btn p-button" (click)="continue()">
      Continuar
      <ion-spinner
        name="crescent"
        slot="end"
        *ngIf="loading; else noLoading"
        color="light"
      ></ion-spinner>
      <ng-template #noLoading>
        <ion-icon name="arrow-forward-outline"></ion-icon>
      </ng-template>
    </button>
  </div>
</div>
